import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export type CatalogType =
  | 'concepts'
  | 'movement_types'
  | 'movement_details'
  | 'departments'
  | 'financial_locations'
  | 'currency_types'
  | 'suppliers'
  | 'contractors';

export interface CatalogItem {
  id: string;
  name: string;
  description?: string;
  is_active: number;
  created_at: number;
  updated_at: number;
  [key: string]: any;
}

export const catalogService = {
  async list(
    type: CatalogType,
    filters?: { kind?: 'I' | 'E'; activeOnly?: boolean }
  ): Promise<CatalogItem[]> {
    const params = new URLSearchParams();
    if (filters?.kind) params.append('kind', filters.kind);
    if (filters?.activeOnly === false) params.append('active_only', 'false');
    const query = params.toString();

    const response = await authService.fetchWithAuth(
      `${API_URL}/api/catalogs/${type}${query ? `?${query}` : ''}`
    );
    return response.data || [];
  },

  async get(type: CatalogType, id: string): Promise<CatalogItem> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/catalogs/${type}/${id}`
    );
    return response.data;
  },

  async create(type: CatalogType, data: Partial<CatalogItem>): Promise<CatalogItem> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/catalogs/${type}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async update(
    type: CatalogType,
    id: string,
    data: Partial<CatalogItem>
  ): Promise<CatalogItem> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/catalogs/${type}/${id}`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      }
    );
    return response.data;
  },

  async toggleActive(type: CatalogType, id: string): Promise<CatalogItem> {
    const response = await authService.fetchWithAuth(
      `${API_URL}/api/catalogs/${type}/${id}/toggle`,
      { method: 'PATCH' }
    );
    return response.data;
  },
};